import { AUTO_APPROVE_DELIVERIES } from 'root/src/shared/descriptions/endpoints/endpointIds';
import cronJobPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/cronJobPayloadSchema';
export const autoApproveDeliveries = {
    [AUTO_APPROVE_DELIVERIES]: {
        payloadSchema: cronJobPayloadSchema,
    },
};
